module.exports = __webpack_public_path__ + "media/Air Plane Ding-SoundBible.com-496729130.b506a66a.mp3";